import React from 'react';
import { Svg, ISvg } from '../Svg';

export const UX: React.FC<ISvg> = (props) => (
  <Svg viewBox="0 0 50 50" fill="none" {...props}>
    <path
      d="M19.5556 38.056C13.8889 35.8338 9.83334 30.3338 9.83334 23.8893C9.83334 15.5004 16.6111 8.72266 25 8.72266C33.3889 8.72266 40.2222 15.5004 40.2222 23.8893C40.2222 30.6115 35.8889 36.2782 29.8333 38.2782"
      stroke="#737BF8"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M26.7778 47.7776H22.9444C21 47.7776 19.3889 46.2776 19.3889 44.3887V23.7776L24.8333 16.3887L30.2778 23.7776V44.4442C30.3333 46.2776 28.7778 47.7776 26.7778 47.7776Z"
      stroke="#737BF8"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M29.3333 41.1113H20"
      stroke="#737BF8"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M29.3333 23.834H19.9444"
      stroke="#737BF8"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M24.8889 24.8887V40.4442"
      stroke="#737BF8"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M24.8889 1.5V4.77778"
      stroke="#737BF8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M9 8.11133L11.3333 10.3891"
      stroke="#737BF8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M38.5 37.5547L40.7778 39.8325"
      stroke="#737BF8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M2.44444 23.9453H5.66666"
      stroke="#737BF8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M44.1111 23.9453H47.3333"
      stroke="#737BF8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M9 39.8325L11.3333 37.5547"
      stroke="#737BF8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M38.5 10.3891L40.7778 8.11133"
      stroke="#737BF8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </Svg>
);
